/**
 * Created by bing on 2017/11/16.
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  LoginUser: {},
  currentPath: '',
  tableLoading:{
    1:false,
    2:false,
    3:false,
  },
  emp:[],
  dept:[],
  tasKeyMap:{}
}
const mutations = {
  setLoginUser(state,info){
    state.LoginUser = info
  },
  setCurrentPath(state,val){
    state.currentPath = val
  },
  setLoading(state,level){
    state.tableLoading[level] = true
  },
  cancelLoading(state,level){
    state.tableLoading[level] = false
  },
  saveEmployee(state,e){
    state.emp = e
  },
  saveDepartment(state,d){
    state.dept = d
  },
  setTasKeyMa(state,val){
    state.tasKeyMap = val
  }
}
export default  new Vuex.Store({
  state, mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js